// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from '../id.js'
import {IndexData, unionListToIndexData, unionToIndexData} from '../search-index/index-data.js'
import {IndexType} from '../search-index/index-type.js'

export class NoteSearchIndex {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): NoteSearchIndex {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsNoteSearchIndex(bb: flatbuffers.ByteBuffer, obj?: NoteSearchIndex): NoteSearchIndex {
    return (obj || new NoteSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsNoteSearchIndex(bb: flatbuffers.ByteBuffer, obj?: NoteSearchIndex): NoteSearchIndex {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new NoteSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static bufferHasIdentifier(bb: flatbuffers.ByteBuffer): boolean {
    return bb.__has_identifier('NSIX')
  }

  indexType(): IndexType {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : IndexType.Text
  }

  indexDataType(): IndexData {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : IndexData.NONE
  }

  indexData<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  maxOpId(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  maxServerTime(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  static startNoteSearchIndex(builder: flatbuffers.Builder) {
    builder.startObject(5)
  }

  static addIndexType(builder: flatbuffers.Builder, indexType: IndexType) {
    builder.addFieldInt8(0, indexType, IndexType.Text)
  }

  static addIndexDataType(builder: flatbuffers.Builder, indexDataType: IndexData) {
    builder.addFieldInt8(1, indexDataType, IndexData.NONE)
  }

  static addIndexData(builder: flatbuffers.Builder, indexDataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, indexDataOffset, 0)
  }

  static addMaxOpId(builder: flatbuffers.Builder, maxOpIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, maxOpIdOffset, 0)
  }

  static addMaxServerTime(builder: flatbuffers.Builder, maxServerTime: bigint) {
    builder.addFieldInt64(4, maxServerTime, null)
  }

  static endNoteSearchIndex(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 8) // index_data
    builder.requiredField(offset, 10) // max_op_id
    return offset
  }

  static finishNoteSearchIndexBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, 'NSIX')
  }

  static finishSizePrefixedNoteSearchIndexBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, 'NSIX', true)
  }
}
